import {AppLocale} from '@config/locales';
import {IGatewayResponse} from 'model/api';
import {CurrencyEnum} from '../countries/countries.model';

export interface IUserResponse extends IGatewayResponse {
    user: IUser;
}

export interface IProfileResponse {
    profile: IUserProfile;
}

export interface IUserProfile {
    username: string;
    avatar_url: string;
    is_employee?: boolean;
}

export interface IUser {
    id: number;
    username: string;
    email: string;
    selectedLocale: AppLocale;
    created: string;
    lastLogin: string;
    confirmationToken: string;
    passwordRequestedAt: string;
    isChargebee: boolean;
    roles: UserRolesEnum[];
    address: {
        firstName: string;
        lastName: string;
        address: string;
        city: string;
        postalCode: string;
        country: string;
        countryCode: number;
        company: string;
        stateCode: string | null;
    };
    subscription: {
        itemPriceId: string;
        aboCanceled: boolean;
        aboCanceledDate: string;
        aboValidUntilDate: string;
        aboDisabled: boolean;
        aboDisabledReason: string;
        aboOrderDate: string;
        subscriptionId: string;
        billingCyclesRemaining: number;
        nextAboId: string;
        futureItemPriceId: string;
        futureSubscriptionId: string;
        futureActionAtTermEnd: string;
        futureSubscriptionStartDate: string;
        futureSubscriptionEndDate: string;
        futureSubscriptionBillingCyclesRemaining: number;
        subscriptionActivatedAt: string;
        subscriptionTrialStartedAt: string;
        subscriptionTrialEndAt: string;
        currentSubscriptionState: string;
    };
    notifications: {
        level: string;
        channel: string;
        created: string;
        messageKey: string;
        messageParameters: {
            additionalProp1: string;
            additionalProp2: string;
            additionalProp3: string;
        };
    }[];
    states: {
        runningSubscription: boolean;
        fullAccess: boolean;
        fullAccessReason: string;
        notifications: boolean;
        eligibleForTrial: boolean;
        subscriptionInTrial: boolean;
    };
    personalRecommendations: boolean;
    personalRecommendationFrequency:
        | PersonalRecommendationSettingEnum.WEEKLY
        | PersonalRecommendationSettingEnum.MONTHLY
        | null;
    currency: CurrencyEnum;
    timezone: string;
}

export enum PersonalRecommendationSettingEnum {
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    NEVER = 'never',
}

export interface ICancelSubscriptionUrlResponse extends IGatewayResponse {
    cancelUrl: string;
}

export interface IUserPaymentDetailsResponse extends IGatewayResponse {
    paymentDetails: IUserPaymentDetails;
}

export interface IUserPaymentDetails {
    paymentMethod: UserPaymentMethodEnum;
}

export enum UserPaymentMethodEnum {
    PAYPAL = 'paypal',
    CREDIT_CARD = 'cc',
    DIRECT_DEBIT = 'elv',
    COUPON = 'coupon',
    CC_MIGRATED = 'cc_migrated',
    ELV_MIGRATE = 'elv_migrate',
    ELV_MIGRATED = 'elv_migrated',
    EMPTY = '',
}

export enum UserRolesEnum {
    SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
    ADMIN = 'ROLE_ADMIN',
    PAYMENT = 'ROLE_PAYMENT',
    USER = 'ROLE_USER',
}
